import styled, { css } from 'styled-components'
import {
  radioSizeOption,
  radioDirectionOptions,
  radioSizeOptions
} from './constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'
import colorsOptions from '../../fundamentals/colors-styles/constants'

const textSize = {
  small: textStyleSizeOptions['TEXT-R'],
  medium: textStyleSizeOptions['TEXT-L'],
  large: textStyleSizeOptions['TEXT-XL']
}

const StyledRadioContainer = styled.div`
  display: flex;
  align-items: center;
  ${({ size = radioSizeOptions.MEDIUM }) => css`
    gap: ${radioSizeOption[size]?.gap};
  `}
`

const StyledRadioGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: ${({ direction = radioDirectionOptions.COL }) =>
    direction === radioDirectionOptions.ROW ? 'row' : 'column'};
`

const StyledRadioIndicator = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  &:after {
    content: '';
    display: block;
    ${({ size = radioSizeOptions.MEDIUM }) => css`
      ${radioSizeOption[size]?.indicator};
    `}
    border-radius: 50%;
    background-color: ${colorsOptions.greys['grey-90']};
  }
`

const StyledRadioItem = styled.button`
  all: unset;

  background-color: white;
  border-radius: 100%;
  border: 1px solid ${colorsOptions.greys['grey-90']};

  ${({ size = radioSizeOptions.MEDIUM }) => css`
    ${radioSizeOption[size]}
  `}

  &:focus-visible {
    outline: none;
    box-shadow:
      0 0 0 1px ${colorsOptions.greys.white},
      0 0 0 3px ${colorsOptions.docuToolsOrange.orange};
  }
  &:disabled {
    cursor: not-allowed;
    opacity: '50%';
    border-color: ${colorsOptions.greys['grey-40']};
    ${StyledRadioIndicator} {
      &:after {
        background-color: ${colorsOptions.greys['grey-40']};
      }
    }
  }
  &:hover {
    border-color: ${colorsOptions.greys['grey-100']};

    ${StyledRadioIndicator} {
      &:after {
        background-color: ${colorsOptions.greys['grey-100']};
      }
    }
  }
`

const StyledLabel = styled.label`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${({ size = radioSizeOptions.MEDIUM }) => css`
    ${textStyleSizeStyleOptions[textSize[size]]}
  `};
  &[data-disabled] {
    color: ${colorsOptions.greys['grey-40']};
  }
`

const StyledRadioEmphasis = styled(StyledRadioItem)`
  border-color: ${colorsOptions.docuToolsOrange.orange};

  ${StyledRadioIndicator} {
    &:after {
      background-color: ${colorsOptions.docuToolsOrange.orange};
    }
  }
`

const StyledRadioIndicatorSkeleton = styled.span`
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  &:after {
    content: '';
    display: block;
    ${({ size = radioSizeOptions.MEDIUM }) => css`
      ${radioSizeOption[size]?.indicator};
    `}
    border-radius: 50%;
    background-color: ${colorsOptions.greys['grey-30']};
  }
`

const StyledRadioItemSkeleton = styled.button`
  all: unset;
  cursor: not-allowed;
  background-color: white;
  border-radius: 100%;
  border: 1px solid ${colorsOptions.greys['grey-30']};

  ${({ size = radioSizeOptions.MEDIUM }) => css`
    ${radioSizeOption[size]}
  `}

  &:focus {
    outline: none;
  }
`

const StyledLabelSkeleton = styled.label`
  background-color: ${colorsOptions.greys['grey-30']};
  color: ${colorsOptions.greys['grey-30']};
  min-width: 80px;
  max-width: 80px;
  border-radius: 4px;
`

export {
  StyledRadioGroup,
  StyledRadioIndicator,
  StyledRadioItem,
  StyledRadioContainer,
  StyledLabel,
  StyledRadioEmphasis,
  StyledRadioIndicatorSkeleton,
  StyledRadioItemSkeleton,
  StyledLabelSkeleton
}
